import React, {useState} from "react";
import PropTypes from 'prop-types';
import TreeView from "@material-ui/lab/TreeView/TreeView";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Divider from "@material-ui/core/Divider";
import TreeRender from "./TreeRender";
import AddNewItemButton from "./AddNewItemButton";
import {useContextMenu} from "../../../../Hooks";
import CreateItemsFromClipboard from "./CreateItemsFromClipboard";

const Schema = (props) => {
    const {
        data, handleSelect, selected, createNewItem,
        deleteItem, focusFirstPropertyField, insertItems
    } = props;
    const {ContextMenu, onOpen} = useContextMenu({
        addAfter: createNewItem,
        addBefore: createNewItem,
        remove: deleteItem
    });
    const [expanded, setExpanded] = useState([]);

    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };
    const onOpenContext = (e, currentPath, arrayPath, index) => {
      handleSelect(e, currentPath);
      onOpen(e, currentPath, arrayPath, index)
    };
    return (
        <>
            <TreeView
                defaultCollapseIcon={<ArrowDropDownIcon/>}
                defaultExpandIcon={<ArrowRightIcon/>}
                expanded={expanded}
                selected={selected}
                onNodeToggle={handleToggle}
                onNodeSelect={handleSelect}
            >
                {TreeRender({
                    data,
                    path: '',
                    createNewItem,
                    deleteItem,
                    handleSelect,
                    focusFirstPropertyField,
                    onOpenContext
                })}
            </TreeView>
            <Divider style={{marginTop: 5}}/>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <AddNewItemButton
                createNewItem={createNewItem}
                index={data.length}
            />
            <CreateItemsFromClipboard
                insertItems={insertItems}
            />
            </div>
            <ContextMenu/>
        </>
    )
};

export default Schema;

Schema.propTypes = {
    data: PropTypes.array,
    createNewItem: PropTypes.func,
    deleteItem: PropTypes.func,
    insertItems: PropTypes.func
};
Schema.defaultProps = {
    data: []
};

